import React from "react";

const ContactPage = () => {
  return (
    <div className="page">
      <h1>Contact Page</h1>
    </div>
  );
};

export default ContactPage;
